import script from "./newlive.vue?vue&type=script&setup=true&lang=js"
export * from "./newlive.vue?vue&type=script&setup=true&lang=js"

import "./newlive.vue?vue&type=style&index=0&id=b3875a48&lang=scss"

const __exports__ = script;

export default __exports__